import { usePermissions } from '../contexts/PermissionContext';

// Azure AD group object IDs (group_id column in azure_ad_groups).
export const GWI360_COMPLIANCE_GROUP_ID = 'c44b19f2-bc06-4aff-8b4d-98e9b3f5114b';
export const GWI360_COMPLIANCE_MANAGER_GROUP_ID = 'd080795e-689a-4907-b3ce-fd7d0a79306c';

export interface ComplianceAccess {
  isManager: boolean;
  hasAny: boolean;
  userOid: string;
  loading: boolean;
}

/**
 * Gates Compliance Portal UI by Azure AD group membership.
 *
 * `isManager` — GWI360-Compliance Manager: approve/review/terminate/import/manage changelog/view audit.
 * `hasAny`    — either group: view/create/edit-own (owner checks stay on the backend).
 * `userOid`   — current user's Azure AD object ID, for client-side owner-edit gating.
 */
export function useComplianceAccess(): ComplianceAccess {
  const { isInGroups, loading, permissions } = usePermissions();
  const isManager = isInGroups([GWI360_COMPLIANCE_MANAGER_GROUP_ID]);
  const isUser = isInGroups([GWI360_COMPLIANCE_GROUP_ID]);
  return {
    isManager,
    hasAny: isManager || isUser,
    userOid: permissions?.user_id ?? '',
    loading,
  };
}
